import apiService from './api';

export interface EmpresaData {
  /** URL pronta da logomarca, montada pelo servidor. */
  logo?: string | null;
  logo_url?: string | null;
  id: number;
  nome: string;
  cnpj: string;
  razao_social?: string;
  telefone?: string;
  email?: string;
  endereco?: string;
  cidade?: string;
  estado?: string;
  cep?: string;
  plano: string;
  ativo: boolean;
  users_count?: number;
  veiculos_count?: number;
  motoristas_count?: number;
  users?: any[];
  created_at: string;
}

export interface SuperAdminStats {
  total_empresas: number;
  empresas_ativas: number;
  empresas_inativas: number;
  total_usuarios: number;
  por_plano: {
    basico: number;
    profissional: number;
    enterprise: number;
  };
  ultimas_empresas: EmpresaData[];
}

export const superAdminService = {
  getStats: async () => {
    return apiService.get<{ success: boolean; data: SuperAdminStats }>('/super-admin/stats');
  },

  getEmpresas: async (params: { search?: string; plano?: string; ativo?: string; per_page?: number; page?: number } = {}) => {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== '') query.append(k, String(v));
    });
    return apiService.get<any>(`/super-admin/empresas?${query.toString()}`);
  },

  getEmpresa: async (id: number) => {
    return apiService.get<any>(`/super-admin/empresas/${id}`);
  },

  createEmpresa: async (data: any) => {
    return apiService.post<any>('/super-admin/empresas', data);
  },

  /**
   * Envia a logomarca de uma empresa que ja existe.
   *
   * Precisa do id, entao no cadastro a empresa e criada primeiro e a logo vai em
   * seguida: gravar o arquivo antes deixaria um arquivo orfao se a criacao
   * falhasse na validacao.
   */
  enviarLogo: async (empresaId: number, arquivo: File) => {
    const dados = new FormData();
    dados.append('logo', arquivo);
    return apiService.post<{ success: boolean; message: string; data: EmpresaData }>(
      `/super-admin/empresas/${empresaId}/logo`,
      dados,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
  },

  removerLogo: async (empresaId: number) => {
    return apiService.delete<{ success: boolean; message: string; data: EmpresaData }>(
      `/super-admin/empresas/${empresaId}/logo`,
    );
  },

  updateEmpresa: async (id: number, data: any) => {
    return apiService.put<any>(`/super-admin/empresas/${id}`, data);
  },

  deleteEmpresa: async (id: number) => {
    return apiService.delete<any>(`/super-admin/empresas/${id}`);
  },

  toggleStatus: async (id: number) => {
    return apiService.post<any>(`/super-admin/empresas/${id}/toggle-status`);
  },

  getUsers: async (empresaId: number) => {
    return apiService.get<any>(`/super-admin/empresas/${empresaId}/users`);
  },

  addUser: async (empresaId: number, data: any) => {
    return apiService.post<any>(`/super-admin/empresas/${empresaId}/users`, data);
  },

  removeUser: async (empresaId: number, userId: number) => {
    return apiService.delete<any>(`/super-admin/empresas/${empresaId}/users/${userId}`);
  },

  // Gestao global de usuarios: atravessa todas as empresas
  getUsuariosGlobal: async (filtros: {
    empresa_id?: number; role?: string; ativo?: boolean; search?: string; per_page?: number;
  } = {}) => {
    const params = new URLSearchParams();
    Object.entries(filtros).forEach(([chave, valor]) => {
      if (valor !== undefined && valor !== '') params.append(chave, String(valor));
    });
    const query = params.toString();
    return apiService.get<any>(`/super-admin/usuarios${query ? '?' + query : ''}`);
  },

  getUsuariosStats: async () => {
    return apiService.get<any>('/super-admin/usuarios/stats');
  },

  toggleUsuarioStatus: async (userId: number) => {
    return apiService.post<any>(`/super-admin/usuarios/${userId}/toggle-status`);
  },
};
